import { SCHEDULED, WALK_IN } from './queueTypes';

export const SORT_FIELDS_TYPES = {
  START_TIME: 'START_TIME',
  CLOSED_TIME: 'CLOSED_TIME',
  ESTIMATED_TIME: 'ESTIMATED_TIME',
  PROVIDER_NAME: 'PROVIDER_NAME',
  CUSTOMER_NAME: 'CUSTOMER_NAME',
  SUBJECT_NAME: 'SUBJECT_NAME',
  LAST_CONVERSATION_STATUS: 'LAST_CONVERSATION_STATUS',
  SERVICE_NAME: 'SERVICE_NAME',
  CONVERSATION_TYPE: 'CONVERSATION_TYPE',
};

export const DATERANGE_TYPES = {
  SCHEDULED: 'SCHEDULED',
  CLOSED: 'CLOSED',
};

export const CONVERSATION_STATUSES_TYPES = {
  CONNECTING: 'CONNECTING',
  IN_PROGRESS: 'IN_PROGRESS',
  ENDED: 'ENDED',
  DISCONNECTED: 'DISCONNECTED',
  FAILED: 'FAILED',
  UNANSWERED: 'UNANSWERED',
  DECLINED: 'DECLINED',
  CREATED: 'CREATED',
  NO_CONVERSATION: 'NO_CONVERSATION',
};

export const APPOINTMENT_STATUSES_TYPES = {
  UPCOMING: 'UPCOMING',
  OVERDUE: 'OVERDUE',
  ONGOING: 'ONGOING',
};

export const CLOSE_REASONS_TYPES = {
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  COULD_NOT_CONNECT: 'COULD_NOT_CONNECT',
};

export const SORT_FIELDS = [
  // {
  //   key: SORT_FIELDS_TYPES.ESTIMATED_TIME,
  //   label: { id: 'Appointments.Sort.ETL', defaultMessage: '** ETL' },
  // },
  {
    key: SORT_FIELDS_TYPES.START_TIME,
    label: { id: 'Appointments.AppointmentsList.SortOption.Title.Schedule', defaultMessage: '** Schedule' },
  },
  {
    key: SORT_FIELDS_TYPES.CLOSED_TIME,
    label: { id: 'Appointments.AppointmentsList.Archived.SortOption.Title.CloseTime', defaultMessage: '** Close time' },
  },
  {
    key: SORT_FIELDS_TYPES.PROVIDER_NAME,
    label: { id: 'Appointments.AppointmentsList.SortOption.Title.Provider', defaultMessage: '** Participant' },
  },
  {
    key: SORT_FIELDS_TYPES.CUSTOMER_NAME,
    label: { id: 'Appointments.AppointmentsList.SortOption.Title.Customer', defaultMessage: '** Customer' },
  },
  {
    key: SORT_FIELDS_TYPES.SUBJECT_NAME,
    label: { id: 'Appointments.AppointmentsList.SortOption.Title.Subject', defaultMessage: '** Regarding' },
  },
  {
    key: SORT_FIELDS_TYPES.LAST_CONVERSATION_STATUS,
    label: { id: 'Appointments.AppointmentsList.SortOption.Title.LastConversationStatus', defaultMessage: '**Last conversation status' },
  },
  {
    key: SORT_FIELDS_TYPES.SERVICE_NAME,
    label: { id: 'Appointments.AppointmentsList.SortOption.Title.Service', defaultMessage: '** Service' },
  },
  {
    key: SORT_FIELDS_TYPES.CONVERSATION_TYPE,
    label: { id: 'Appointments.AppointmentsList.Filter.FilterOption.ConversationType.Title', defaultMessage: '** Conversation Type' },
  },
];

export const SORT_DIRECTIONS = {
  ASC: {
    id: 'Appointments.AppointmentsList.SortButton.Tooltip.SortOrder.Ascending',
    defaultMessage: '** Ascending',
  },
  DESC: {
    id: 'Appointments.AppointmentsList.SortButton.Tooltip.SortOrder.Descending',
    defaultMessage: '** Descending',
  },
};

export const DATE_RANGES = [
  {
    key: DATERANGE_TYPES.SCHEDULED,
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.Date.Option.ScheduledStartTime',
      defaultMessage: '** Scheduled start time',
    },
  },
  {
    key: DATERANGE_TYPES.CLOSED,
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.Date.Option.ClosedTime',
      defaultMessage: '** Closed time',
    },
  },
];

export const APPOINTMENT_STATUSES = [
  {
    key: APPOINTMENT_STATUSES_TYPES.UPCOMING,
    label: {
      id: 'Appointments.AppointmentsList.Filter.AppointmentLastConversation.Values.Upcoming',
      defaultMessage: '** Upcoming',
    },
  },
  {
    key: APPOINTMENT_STATUSES_TYPES.OVERDUE,
    label: {
      id: 'Appointments.AppointmentsList.Filter.AppointmentLastConversation.Values.Overdue',
      defaultMessage: '** Overdue',
    },
  },
  {
    key: APPOINTMENT_STATUSES_TYPES.ONGOING,
    label: {
      id: 'Appointments.AppointmentsList.Filter.AppointmentLastConversation.Values.Ongoing',
      defaultMessage: '** Ongoing',
    },
  },
];

export const CONVERSATION_STATUSES = [
  {
    key: CONVERSATION_STATUSES_TYPES.ENDED,
    label: {
      id: 'General.ConversationStatus.Ended',
      defaultMessage: '** Ended',
    },
  },
  {
    key: CONVERSATION_STATUSES_TYPES.UNANSWERED,
    label: {
      id: 'General.ConversationStatus.Unanswered',
      defaultMessage: '** Unanswered',
    },
  },
  {
    key: CONVERSATION_STATUSES_TYPES.DISCONNECTED,
    label: {
      id: 'General.ConversationStatus.Disconnected',
      defaultMessage: '** Disconnected',
    },
  },
  {
    key: CONVERSATION_STATUSES_TYPES.IN_PROGRESS,
    label: {
      id: 'General.ConversationStatus.InProgress',
      defaultMessage: '** In progress',
    },
  },
  {
    key: CONVERSATION_STATUSES_TYPES.CONNECTING,
    label: {
      id: 'General.ConversationStatus.Connecting',
      defaultMessage: '** Connecting',
    },
  },
  {
    key: CONVERSATION_STATUSES_TYPES.DECLINED,
    label: {
      id: 'General.ConversationStatus.Declined',
      defaultMessage: '** Declined',
    },
  },
  {
    key: CONVERSATION_STATUSES_TYPES.NO_CONVERSATION,
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.LastConversationStatus.NoConversations',
      defaultMessage: '** No conversations',
    },
  },
];

export const CLOSE_REASONS = [
  {
    key: CLOSE_REASONS_TYPES.COMPLETED,
    label: {
      id: 'Appointment.CloseReason.Completed',
      defaultMessage: '** Completed',
    },
  },
  {
    key: CLOSE_REASONS_TYPES.CANCELED,
    label: {
      id: 'Appointment.CloseReason.Canceled',
      defaultMessage: '** Canceled',
    },
  },
  {
    key: CLOSE_REASONS_TYPES.COULD_NOT_CONNECT,
    label: {
      id: 'Appointment.CloseReason.CouldNotConnectWithParticipants',
      defaultMessage: '** Could not connect with participants',
    },
  },
];

export const SCHEDULES = [
  {
    key: SCHEDULED,
    label: {
      id: 'Appointments.Filters.Schedule.Scheduled',
      defaultMessage: '** Scheduled',
    },
  },
  {
    key: WALK_IN,
    label: {
      id: 'Appointments.Filters.Schedule.WalkIn',
      defaultMessage: '** Walk-in',
    },
  },
];

export const IS_GROUPED_APPOINTMENT = [
  {
    key: 'YES',
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.GroupOfAppointments.Yes',
      defaultMessage: '** Yes',
    },
  },
  {
    key: 'NO',
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.GroupOfAppointments.No',
      defaultMessage: '** No',
    },
  },
];

export const CONVERSATION_TYPES = [
  {
    key: 'AUDIO_EXTERNAL',
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.ConversationType.Audio',
      defaultMessage: '** Audio',
    },
  },
  {
    key: 'VIDEO',
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.ConversationType.Video',
      defaultMessage: '** Video',
    },
  },
  // {
  //   key: 'TEXT',
  //   label: {
  //     id: 'Appointments.AppointmentsList.Filter.FilterOption.ConversationType.Text',
  //     defaultMessage: '** Text',
  //   },
  // },
  {
    key: 'FACE_TO_FACE',
    label: {
      id: 'Appointments.AppointmentsList.Filter.FilterOption.ConversationType.F2F',
      defaultMessage: '** Face to Face',
    },
  },
];

